<template>
    <div class="multiple-popup-wrap" :style="{ width: width + 'px', height: height + 'px' }">
        <ul class="option-list-content scroll-tracker" v-if="options.length">
            <li
                class="option-list-item"
                v-for="menu in options"
                :class="{ 'option-selected': getItemStatus(menu) }"
                :key="menu.id"
                @click.stop="clickHandler(menu)"
            >
                <span>{{ menu.label }}</span>
                <Icon class="option-right-icon" :width="14" :height="14" bgPosition="-126px -18px" v-if="isShowIcon" />
            </li>
        </ul>
        <span class="option-tip" v-else>{{ $t("zhiji.common.noRelateData") }}</span>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "MultiplePopupMenu",
    props: ["width", "height", "options", "selected", "isShowIcon"],
    components: {
        Icon
    },
    methods: {
        clickHandler(menu) {
            this.$emit("menuClick", menu);
        },
        getItemStatus(menu) {
            return this.selected.some(item => {
                return item.id == menu.id;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.multiple-popup-wrap {
    max-height: 320px;
    margin-top: 5px;
    background: #fff;
    border-radius: 4px;
    z-index: 1;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    .option-list-content {
        flex: 1;
        height: 100%;
        overflow: auto;
    }
    .option-tip {
        color: #9e9e9e;
    }
    .option-list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 8px 8px;
        word-break: break-all;
        word-wrap: break-word;
        cursor: pointer;

        &:hover {
            background: rgba(217, 235, 246, 0.7);
            color: #2ec2ff;
        }

        .option-right-icon {
            margin-left: 2px;
        }
    }

    .option-selected {
        background: rgba(217, 235, 246, 0.7);
        color: #2ec2ff;
    }
}
</style>
